import React, { useState } from 'react';
import { useAppDispatch, useAppSelector } from 'hooks';
import { Dropdown, DropdownItem, DropdownMenu, DropdownToggle, Label } from 'reactstrap';

import { TooltipPortal } from '~components';
import Icon, { faEye, faEyeSlash } from '~components/icon';

import { toggleOption } from '~weekly-planner/reducers/weeklyPlanner';

import { selectOptions } from '~weekly-planner/selectors';

const MissingQualificationsViewMenu: React.FC = () => {
  const dispatch = useAppDispatch();
  const { missingQualificationsExtendedQualifications } = useAppSelector(selectOptions);
  const [isViewOpen, setIsViewOpen] = useState(false);

  const renderItem = (onClick: (value?: any) => void, iconToggle: boolean, label: any) => (
    <DropdownItem toggle={false} onClick={onClick}>
      <Icon icon={iconToggle ? faEye : faEyeSlash} className="mt-1" />
      <Label className="ms-2 mb-0">{label}</Label>
    </DropdownItem>
  );

  return (
    <Dropdown isOpen={isViewOpen} toggle={() => setIsViewOpen(!isViewOpen)} className="filter-menu clickable-button">
      <DropdownToggle
        size="sm"
        className="clickable-icon clickable-small icon-round ms-2"
        id="missing-qualifications-tooltip"
        tag={'div'}
      >
        <Icon icon={faEye} />
      </DropdownToggle>
      <TooltipPortal targetId="missing-qualifications-tooltip" content={'View Options'} />

      <DropdownMenu>
        <DropdownItem header>View Options</DropdownItem>
        {renderItem(
          () =>
            dispatch(
              toggleOption({
                key: 'missingQualificationsExtendedQualifications',
                toggle: !missingQualificationsExtendedQualifications,
              }),
            ),
          missingQualificationsExtendedQualifications,
          'Detailed Qualifications',
        )}
      </DropdownMenu>
    </Dropdown>
  );
};

export default MissingQualificationsViewMenu;
